import PriceTargetOutline from '@simplywallst/ui-core/icons/PriceTargetOutline';
import WarrenSolid from '@simplywallst/ui-core/icons/WarrenSolid';

import { NarrativeAuthorAvatar } from '@/components/NarrativeAuthor';
import { cn } from '@simplywallst/ui-core/next';

type Props = {
  type: string;
  owner?: {
    displayName: string | null;
    imageUrl: string | null;
  };
};

export const PrimaryNarrativeIcon = ({ type, owner }: Props) => {
  const className = cn(
    'relative grid size-6 content-center items-center justify-center overflow-hidden rounded-full bg-p-grey-10'
  );

  if (type === 'dcf') {
    return (
      <div className={className}>
        <WarrenSolid className="w-5" aria-label="discounted-cash-flow" />
      </div>
    );
  }

  if (type === 'analysts') {
    return (
      <div className={className}>
        <PriceTargetOutline
          className="w-6 fill-accent"
          aria-label="analyst-price-target"
        />
      </div>
    );
  }

  if (type === 'user_defined' && owner) {
    return (
      <NarrativeAuthorAvatar
        owner={{
          displayName: owner?.displayName ?? 'Simply Wall St User',
          imageUrl: owner?.imageUrl ?? null,
        }}
        size="sm"
      />
    );
  }

  return null;
};
